import React from 'react';
import styles from './Detail.module.scss';
import { TONE_COLOR, Tone } from '../detail';

interface StatusBadgeProps {
  tone?: Tone;
  label: string;
}

/** A coloured dot and a word - the status column of every Detailmasken table. */
const StatusBadge: React.FC<StatusBadgeProps> = ({ tone = 'neutral', label }) => (
  <span className={styles.badge}>
    <span className={styles.dot} style={{ background: TONE_COLOR[tone] }} />
    {label}
  </span>
);

export default StatusBadge;
